var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"marker",attrs:{"src":_vm.currentImage.compressedUrl,"width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }